import React, { Component } from 'react'
import { connect } from 'react-redux'
import { AppSettings, Storage } from '../../configs'

import { logoutAction } from '../../redux/actions/UserAction'
import { ClearMasterAction } from '../../redux/actions/MasterAction'
import { setNotActivePOAction } from '../../redux/actions/DocControlAction'
import Avatar from '@material-ui/core/Avatar';
import moment from 'moment'
const initial_hamberger_status = {
    aria_expanded: false,
    class: 'collapsed',
    collapsed: 'collapse',
};



class TableCommittee extends Component {
    constructor(props) {
        super(props)
        this.state = {
            hamberger_status: initial_hamberger_status,
            isExpand : this.props.isExpand === undefined || this.props.isExpand=== 'Y',
        };
        this.handleCollapse = this.handleCollapse.bind(this)
    }

    handleCollapse() {
        
        window.$('#collapseItemOverview'+this.props.id).toggleClass('show');
        window.$('#collapseItemOverview'+this.props.id).focus();
        const {isExpand} = this.state
        this.setState({...this.state,isExpand:!isExpand})

    }

    render() {

        const {isExpand} = this.state
        return (
            <div  >
                <div className={isExpand===true ? "collapse collapse-onlinereviewer2 show" : "collapse collapse-onlinereviewer2" } id={"collapseItemOverview"+this.props.id} >
                <div className="sp-page-wrapper">
                        <div className="sp-table-container">
                            <div className="row no-gutters">
                                            <table className="sp-table table rrs-table rrs-table-purple">
                                                <thead>
                                                    <tr className="sp-table-header">
                                                        {/* <th className="th-no"><div className="th-text">ลำดับ</div></th> */}
                                                        <th className="th-docnum"><div className="th-text">ชื่อ - นามสกุล</div></th>
                                                        <th className="th-projectname"><div className="th-text">หน่วยงาน</div></th>
                                                        <th className="th-budget"><div className="th-text">โทรศัพท์</div></th>
                                                        <th className="th-method"><div className="th-text">Email</div></th>
                                                        <th className="centerdata th-method"><div className="th-text">ผลการตรวจรับ</div></th>
                                                        <th className="centerdata th-method"><div className="th-text">ยืนยันผลการตรวจรับ</div></th>
                                                        <th className="centerdata th-method"><div className="th-text">วันที่ยืนยันผล</div></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.props.t_PO_COMMITTEE && (this.props.t_PO_COMMITTEE).map((item, index) => (
                                                        <tr key={index + 1}>
                                                            {/* <td className="td-num">{item.sequence}</td> */}
                                                            <td className="nowrap-whitespace text-left">{item.fullname + " (" + item.code + ")"}</td>
                                                            <td className="nowrap-whitespace text-left">{item.department}</td>
                                                            <td className="nowrap-whitespace text-left">{item.telephone}</td>
                                                            <td className="text-left"><a href={"mailto:" + item.email + ";"}>{item.email}</a></td>
                                                            <td className="nowrap-whitespace text-left">{item.approve_status===null?'':item.approve_status ==='Y'?'อนุมัติ': 'ไม่อนุมัติ'}</td>
                                                            <td className="nowrap-whitespace text-left">{item.accept_status===null?'':item.accept_status ==='A'?'อนุมัติตรวจรับงาน': 'ไม่อนุมัติตรวจรับงาน'}</td>
                                                            <td className="nowrap-whitespace text-left">{item.accept_date? moment(item.accept_date).format('DD/MM/YYYY'): ""}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                    

                                    </div>
                                </div>
                            </div> 
                                    
                </div> 
    </div>
        )
    }
}


export default connect(
)(TableCommittee);
